module.exports = __webpack_public_path__ + "assets/3e6003709d92e5c36d3b5bc03de373ea.png";